// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as DeliveryNoteForm from "./DeliveryNoteForm.bs.js";

function get_dn_status(status) {
  if (status === undefined) {
    return ;
  }
  var tmp;
  switch (status) {
    case /* Requested */0 :
        tmp = DeliveryNoteForm.getDNStatusOption("Requested");
        break;
    case /* Cancelled */1 :
        tmp = DeliveryNoteForm.getDNStatusOption("Cancelled");
        break;
    case /* Pending */2 :
        tmp = DeliveryNoteForm.getDNStatusOption("Pending");
        break;
    case /* Delivered */3 :
        tmp = DeliveryNoteForm.getDNStatusOption("Delivered");
        break;
    
  }
  return tmp;
}

function DeliveryNoteCmp(Props) {
  var order = Props.order;
  var user = Props.user;
  var toggleEditOrderSidebar = Props.toggleEditOrderSidebar;
  var changeDiscardModalState = Props.changeDiscardModalState;
  var openSnackbar = Props.openSnackbar;
  var order$1 = order._0;
  var order_id = order$1.order_crn;
  var delivery_note_info = order$1.delivery_note;
  var match = delivery_note_info !== undefined ? [
      delivery_note_info.is_requested,
      delivery_note_info.dn_types,
      {
        hardcopy_status: get_dn_status(delivery_note_info.hardcopy_status),
        softcopy_status: get_dn_status(delivery_note_info.softcopy_status),
        additionalComment: ""
      }
    ] : [
      false,
      /* [] */0,
      {
        hardcopy_status: undefined,
        softcopy_status: undefined,
        additionalComment: ""
      }
    ];
  return React.createElement("div", {
              className: "c-delivery-note-form-container"
            }, React.createElement(DeliveryNoteForm.make, {
                  initial_input: match[2],
                  is_dn_requested: match[0],
                  dn_types: match[1],
                  order_id: order_id,
                  user: user,
                  toggleEditOrderSidebar: toggleEditOrderSidebar,
                  changeDiscardModalState: changeDiscardModalState,
                  openSnackbar: openSnackbar
                }));
}

var make = DeliveryNoteCmp;

export {
  get_dn_status ,
  make ,
  
}
/* react Not a pure module */
